import PosthogService from '~/services/posthog/PosthogService';

export type TLocationSettingsSection =
  | 'basic_information'
  | 'contact'
  | 'address_parking'
  | 'shift_details'
  | 'insurance_software'
  | 'operating_details';

interface ISectionCompletedProperties {
  section: TLocationSettingsSection;
  /** Whether the saved location is the office the app is currently scoped to. */
  is_selected_office: boolean;
}

/**
 * Fires when one Location Details section saves successfully (the API answered 2xx).
 * Event: dental_portal:location_settings:section_completed
 *
 * Replaces `office:account:updated` for offices on `GOTU-7475-account-split-web`:
 * the legacy event fires only from the single Account Information save, which
 * these per-section modals replace.
 */
export function fireLocationSettingsSectionCompleted(
  properties: ISectionCompletedProperties,
): void {
  PosthogService.getInstance().track('dental_portal:location_settings:section_completed', {
    ...properties,
  });
}
